import { Button, Typography } from "@suraasa/placebo-ui"
import { ArrowRightCircle } from "iconoir-react"
import { Link } from "react-router-dom"
import { useEnrollments } from "utils/hooks/useEnrollments"

import QuestionMarkCircle from "../../../../src/assets/icons/question-mark-circle-icon.svg"

const NeedHelpBanner = () => {
  const { hasLearningPrograms: hasEnrollments } = useEnrollments()

  const handleContactClick = () => {
    const subject = "Help Request"
    const body =
      "Hello Suraasa Support Team,\n\nI would like to request assistance with the following:\n\n[Please describe your question or issue here]\n\nThank you,\n[Your Name]"

    return `mailto:care@suraasa.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`
  }
  return (
    hasEnrollments && (
      <div className="rounded-[16px] border border-onSurface-200 p-2.5">
        <div className="flex size-[42px] items-center  justify-center rounded-[22px] bg-onSurface-200">
          <img src={QuestionMarkCircle} alt="" className="size-2.5"></img>
        </div>
        <Typography variant="title4" className="mt-2.5 text-onSurface-700">
          Need Help? We&apos;re Here for You
        </Typography>
        <Typography variant="smallBody" className="mt-1 text-onSurface-500">
          If you have any questions, feel stuck, or just need guidance,
          we&apos;re here to help.
        </Typography>
        <Link to={handleContactClick()}>
          <Button
            variant={"text"}
            endAdornment={<ArrowRightCircle />}
            className="mt-2 p-0"
          >
            Contact Us
          </Button>
        </Link>
      </div>
    )
  )
}

export default NeedHelpBanner
